export default __webpack_public_path__ + "static/media/City-Ride.2654d246.png";